// AUTO-GENERATED from your original dataset (teleport-frontend-main/src/constants/CountryCodes.js).
// Clean, compact shape for UI dropdowns and validation.
// Fields: iso2, code, name, example, display

export const phoneCountryCodes = [
  {
    "iso2": "SG",
    "code": "+65",
    "name": "Singapore",
    "example": "81234567",
    "display": "SG +65"
  },
  {
    "iso2": "AF",
    "code": "+93",
    "name": "Afghanistan",
    "example": "701234567",
    "display": "AF +93"
  },
  {
    "iso2": "AL",
    "code": "+355",
    "name": "Albania",
    "example": "661234567",
    "display": "AL +355"
  },
  {
    "iso2": "DZ",
    "code": "+213",
    "name": "Algeria",
    "example": "551234567",
    "display": "DZ +213"
  },
  {
    "iso2": "AS",
    "code": "+1",
    "name": "American Samoa",
    "example": "6847331234",
    "display": "AS +1"
  },
  {
    "iso2": "AD",
    "code": "+376",
    "name": "Andorra",
    "example": "312345",
    "display": "AD +376"
  },
  {
    "iso2": "AO",
    "code": "+244",
    "name": "Angola",
    "example": "923123456",
    "display": "AO +244"
  },
  {
    "iso2": "AI",
    "code": "+1",
    "name": "Anguilla",
    "example": "2642351234",
    "display": "AI +1"
  },
  {
    "iso2": "AG",
    "code": "+1",
    "name": "Antigua and Barbuda",
    "example": "2684641234",
    "display": "AG +1"
  },
  {
    "iso2": "AR",
    "code": "+54",
    "name": "Argentina",
    "example": "91123456789",
    "display": "AR +54"
  },
  {
    "iso2": "AM",
    "code": "+374",
    "name": "Armenia",
    "example": "77123456",
    "display": "AM +374"
  },
  {
    "iso2": "AW",
    "code": "+297",
    "name": "Aruba",
    "example": "5601234",
    "display": "AW +297"
  },
  {
    "iso2": "AC",
    "code": "+247",
    "name": "Ascension Island",
    "example": null,
    "display": "AC +247"
  },
  {
    "iso2": "AU",
    "code": "+61",
    "name": "Australia",
    "example": "412345678",
    "display": "AU +61"
  },
  {
    "iso2": "AT",
    "code": "+43",
    "name": "Austria",
    "example": "644123456",
    "display": "AT +43"
  },
  {
    "iso2": "AZ",
    "code": "+994",
    "name": "Azerbaijan",
    "example": "401234567",
    "display": "AZ +994"
  },
  {
    "iso2": "BS",
    "code": "+1",
    "name": "Bahamas",
    "example": "2423591234",
    "display": "BS +1"
  },
  {
    "iso2": "BH",
    "code": "+973",
    "name": "Bahrain",
    "example": "36001234",
    "display": "BH +973"
  },
  {
    "iso2": "BD",
    "code": "+880",
    "name": "Bangladesh",
    "example": "1812345678",
    "display": "BD +880"
  },
  {
    "iso2": "BB",
    "code": "+1",
    "name": "Barbados",
    "example": "2462501234",
    "display": "BB +1"
  },
  {
    "iso2": "BY",
    "code": "+375",
    "name": "Belarus",
    "example": "294911911",
    "display": "BY +375"
  },
  {
    "iso2": "BE",
    "code": "+32",
    "name": "Belgium",
    "example": "470123456",
    "display": "BE +32"
  },
  {
    "iso2": "BZ",
    "code": "+501",
    "name": "Belize",
    "example": "6221234",
    "display": "BZ +501"
  },
  {
    "iso2": "BJ",
    "code": "+229",
    "name": "Benin",
    "example": "90011234",
    "display": "BJ +229"
  },
  {
    "iso2": "BM",
    "code": "+1",
    "name": "Bermuda",
    "example": "4413701234",
    "display": "BM +1"
  },
  {
    "iso2": "BT",
    "code": "+975",
    "name": "Bhutan",
    "example": "17123456",
    "display": "BT +975"
  },
  {
    "iso2": "BO",
    "code": "+591",
    "name": "Bolivia",
    "example": "71234567",
    "display": "BO +591"
  },
  {
    "iso2": "BA",
    "code": "+387",
    "name": "Bosnia and Herzegovina",
    "example": "61123456",
    "display": "BA +387"
  },
  {
    "iso2": "BW",
    "code": "+267",
    "name": "Botswana",
    "example": "71123456",
    "display": "BW +267"
  },
  {
    "iso2": "BR",
    "code": "+55",
    "name": "Brazil",
    "example": "1161234567",
    "display": "BR +55"
  },
  {
    "iso2": "IO",
    "code": "+246",
    "name": "British Indian Ocean Territory",
    "example": "3801234",
    "display": "IO +246"
  },
  {
    "iso2": "VG",
    "code": "+1",
    "name": "British Virgin Islands",
    "example": "2843001234",
    "display": "VG +1"
  },
  {
    "iso2": "BN",
    "code": "+673",
    "name": "Brunei",
    "example": "7123456",
    "display": "BN +673"
  },
  {
    "iso2": "BG",
    "code": "+359",
    "name": "Bulgaria",
    "example": "48123456",
    "display": "BG +359"
  },
  {
    "iso2": "BF",
    "code": "+226",
    "name": "Burkina Faso",
    "example": "70123456",
    "display": "BF +226"
  },
  {
    "iso2": "BI",
    "code": "+257",
    "name": "Burundi",
    "example": "79561234",
    "display": "BI +257"
  },
  {
    "iso2": "KH",
    "code": "+855",
    "name": "Cambodia",
    "example": "91234567",
    "display": "KH +855"
  },
  {
    "iso2": "CM",
    "code": "+237",
    "name": "Cameroon",
    "example": "71234567",
    "display": "CM +237"
  },
  {
    "iso2": "CA",
    "code": "+1",
    "name": "Canada",
    "example": "2042345678",
    "display": "CA +1"
  },
  {
    "iso2": "CV",
    "code": "+238",
    "name": "Cape Verde",
    "example": "9911234",
    "display": "CV +238"
  },
  {
    "iso2": "BQ",
    "code": "+599",
    "name": "Caribbean Netherlands",
    "example": "3181234",
    "display": "BQ +599"
  },
  {
    "iso2": "KY",
    "code": "+1",
    "name": "Cayman Islands",
    "example": "3453231234",
    "display": "KY +1"
  },
  {
    "iso2": "CF",
    "code": "+236",
    "name": "Central African Republic",
    "example": "70012345",
    "display": "CF +236"
  },
  {
    "iso2": "TD",
    "code": "+235",
    "name": "Chad",
    "example": "63012345",
    "display": "TD +235"
  },
  {
    "iso2": "CL",
    "code": "+56",
    "name": "Chile",
    "example": "961234567",
    "display": "CL +56"
  },
  {
    "iso2": "CN",
    "code": "+86",
    "name": "China",
    "example": "13123456789",
    "display": "CN +86"
  },
  {
    "iso2": "CX",
    "code": "+61",
    "name": "Christmas Island",
    "example": "412345678",
    "display": "CX +61"
  },
  {
    "iso2": "CC",
    "code": "+61",
    "name": "Cocos [Keeling] Islands",
    "example": "412345678",
    "display": "CC +61"
  },
  {
    "iso2": "CO",
    "code": "+57",
    "name": "Colombia",
    "example": "3211234567",
    "display": "CO +57"
  },
  {
    "iso2": "KM",
    "code": "+269",
    "name": "Comoros",
    "example": "3212345",
    "display": "KM +269"
  },
  {
    "iso2": "CK",
    "code": "+682",
    "name": "Cook Islands",
    "example": "71234",
    "display": "CK +682"
  },
  {
    "iso2": "CR",
    "code": "+506",
    "name": "Costa Rica",
    "example": "83123456",
    "display": "CR +506"
  },
  {
    "iso2": "HR",
    "code": "+385",
    "name": "Croatia",
    "example": "912345678",
    "display": "HR +385"
  },
  {
    "iso2": "CU",
    "code": "+53",
    "name": "Cuba",
    "example": "51234567",
    "display": "CU +53"
  },
  {
    "iso2": "CW",
    "code": "+599",
    "name": "Curaçao",
    "example": "95181234",
    "display": "CW +599"
  },
  {
    "iso2": "CY",
    "code": "+357",
    "name": "Cyprus",
    "example": "96123456",
    "display": "CY +357"
  },
  {
    "iso2": "CZ",
    "code": "+420",
    "name": "Czech Republic",
    "example": "601123456",
    "display": "CZ +420"
  },
  {
    "iso2": "CI",
    "code": "+225",
    "name": "Côte d'Ivoire",
    "example": "01234567",
    "display": "CI +225"
  },
  {
    "iso2": "CD",
    "code": "+243",
    "name": "Democratic Republic Congo",
    "example": "991234567",
    "display": "CD +243"
  },
  {
    "iso2": "DK",
    "code": "+45",
    "name": "Denmark",
    "example": "20123456",
    "display": "DK +45"
  },
  {
    "iso2": "DJ",
    "code": "+253",
    "name": "Djibouti",
    "example": "77831001",
    "display": "DJ +253"
  },
  {
    "iso2": "DM",
    "code": "+1",
    "name": "Dominica",
    "example": "7672251234",
    "display": "DM +1"
  },
  {
    "iso2": "DO",
    "code": "+1",
    "name": "Dominican Republic",
    "example": "8092345678",
    "display": "DO +1"
  },
  {
    "iso2": "TL",
    "code": "+670",
    "name": "East Timor",
    "example": "77212345",
    "display": "TL +670"
  },
  {
    "iso2": "EC",
    "code": "+593",
    "name": "Ecuador",
    "example": "99123456",
    "display": "EC +593"
  },
  {
    "iso2": "EG",
    "code": "+20",
    "name": "Egypt",
    "example": "1001234567",
    "display": "EG +20"
  },
  {
    "iso2": "SV",
    "code": "+503",
    "name": "El Salvador",
    "example": "70123456",
    "display": "SV +503"
  },
  {
    "iso2": "GQ",
    "code": "+240",
    "name": "Equatorial Guinea",
    "example": "222123456",
    "display": "GQ +240"
  },
  {
    "iso2": "ER",
    "code": "+291",
    "name": "Eritrea",
    "example": "7123456",
    "display": "ER +291"
  },
  {
    "iso2": "EE",
    "code": "+372",
    "name": "Estonia",
    "example": "51234567",
    "display": "EE +372"
  },
  {
    "iso2": "SZ",
    "code": "+268",
    "name": "Eswatini",
    "example": "76123456",
    "display": "SZ +268"
  },
  {
    "iso2": "ET",
    "code": "+251",
    "name": "Ethiopia",
    "example": "911234567",
    "display": "ET +251"
  },
  {
    "iso2": "FK",
    "code": "+500",
    "name": "Falkland Islands [Islas Malvinas]",
    "example": "51234",
    "display": "FK +500"
  },
  {
    "iso2": "FO",
    "code": "+298",
    "name": "Faroe Islands",
    "example": "211234",
    "display": "FO +298"
  },
  {
    "iso2": "FJ",
    "code": "+679",
    "name": "Fiji",
    "example": "7012345",
    "display": "FJ +679"
  },
  {
    "iso2": "FI",
    "code": "+358",
    "name": "Finland",
    "example": "412345678",
    "display": "FI +358"
  },
  {
    "iso2": "FR",
    "code": "+33",
    "name": "France",
    "example": "612345678",
    "display": "FR +33"
  },
  {
    "iso2": "GF",
    "code": "+594",
    "name": "French Guiana",
    "example": "694201234",
    "display": "GF +594"
  },
  {
    "iso2": "PF",
    "code": "+689",
    "name": "French Polynesia",
    "example": "212345",
    "display": "PF +689"
  },
  {
    "iso2": "GA",
    "code": "+241",
    "name": "Gabon",
    "example": "06031234",
    "display": "GA +241"
  },
  {
    "iso2": "GM",
    "code": "+220",
    "name": "Gambia",
    "example": "3012345",
    "display": "GM +220"
  },
  {
    "iso2": "GE",
    "code": "+995",
    "name": "Georgia",
    "example": "555123456",
    "display": "GE +995"
  },
  {
    "iso2": "DE",
    "code": "+49",
    "name": "Germany",
    "example": "15123456789",
    "display": "DE +49"
  },
  {
    "iso2": "GH",
    "code": "+233",
    "name": "Ghana",
    "example": "231234567",
    "display": "GH +233"
  },
  {
    "iso2": "GI",
    "code": "+350",
    "name": "Gibraltar",
    "example": "57123456",
    "display": "GI +350"
  },
  {
    "iso2": "GR",
    "code": "+30",
    "name": "Greece",
    "example": "6912345678",
    "display": "GR +30"
  },
  {
    "iso2": "GL",
    "code": "+299",
    "name": "Greenland",
    "example": "221234",
    "display": "GL +299"
  },
  {
    "iso2": "GD",
    "code": "+1",
    "name": "Grenada",
    "example": "4734031234",
    "display": "GD +1"
  },
  {
    "iso2": "GP",
    "code": "+590",
    "name": "Guadeloupe",
    "example": "690301234",
    "display": "GP +590"
  },
  {
    "iso2": "GU",
    "code": "+1",
    "name": "Guam",
    "example": "6713001234",
    "display": "GU +1"
  },
  {
    "iso2": "GT",
    "code": "+502",
    "name": "Guatemala",
    "example": "51234567",
    "display": "GT +502"
  },
  {
    "iso2": "GG",
    "code": "+44",
    "name": "Guernsey",
    "example": "7781123456",
    "display": "GG +44"
  },
  {
    "iso2": "GN",
    "code": "+224",
    "name": "Guinea Conakry",
    "example": "60201234",
    "display": "GN +224"
  },
  {
    "iso2": "GW",
    "code": "+245",
    "name": "Guinea-Bissau",
    "example": "5012345",
    "display": "GW +245"
  },
  {
    "iso2": "GY",
    "code": "+592",
    "name": "Guyana",
    "example": "6091234",
    "display": "GY +592"
  },
  {
    "iso2": "HT",
    "code": "+509",
    "name": "Haiti",
    "example": "34101234",
    "display": "HT +509"
  },
  {
    "iso2": "HM",
    "code": "+672",
    "name": "Heard Island and McDonald Islands",
    "example": null,
    "display": "HM +672"
  },
  {
    "iso2": "HN",
    "code": "+504",
    "name": "Honduras",
    "example": "91234567",
    "display": "HN +504"
  },
  {
    "iso2": "HK",
    "code": "+852",
    "name": "Hong Kong",
    "example": "51234567",
    "display": "HK +852"
  },
  {
    "iso2": "HU",
    "code": "+36",
    "name": "Hungary",
    "example": "201234567",
    "display": "HU +36"
  },
  {
    "iso2": "IS",
    "code": "+354",
    "name": "Iceland",
    "example": "6101234",
    "display": "IS +354"
  },
  {
    "iso2": "IN",
    "code": "+91",
    "name": "India",
    "example": "9123456789",
    "display": "IN +91"
  },
  {
    "iso2": "ID",
    "code": "+62",
    "name": "Indonesia",
    "example": "812345678",
    "display": "ID +62"
  },
  {
    "iso2": "IR",
    "code": "+98",
    "name": "Iran",
    "example": "9123456789",
    "display": "IR +98"
  },
  {
    "iso2": "IQ",
    "code": "+964",
    "name": "Iraq",
    "example": "7912345678",
    "display": "IQ +964"
  },
  {
    "iso2": "IE",
    "code": "+353",
    "name": "Ireland",
    "example": "850123456",
    "display": "IE +353"
  },
  {
    "iso2": "IM",
    "code": "+44",
    "name": "Isle of Man",
    "example": "7924123456",
    "display": "IM +44"
  },
  {
    "iso2": "IL",
    "code": "+972",
    "name": "Israel",
    "example": "501234567",
    "display": "IL +972"
  },
  {
    "iso2": "IT",
    "code": "+39",
    "name": "Italy",
    "example": "3123456789",
    "display": "IT +39"
  },
  {
    "iso2": "JM",
    "code": "+1",
    "name": "Jamaica",
    "example": "8762101234",
    "display": "JM +1"
  },
  {
    "iso2": "JP",
    "code": "+81",
    "name": "Japan",
    "example": "7012345678",
    "display": "JP +81"
  },
  {
    "iso2": "JE",
    "code": "+44",
    "name": "Jersey",
    "example": "7797123456",
    "display": "JE +44"
  },
  {
    "iso2": "JO",
    "code": "+962",
    "name": "Jordan",
    "example": "790123456",
    "display": "JO +962"
  },
  {
    "iso2": "KZ",
    "code": "+7",
    "name": "Kazakhstan",
    "example": "7710009998",
    "display": "KZ +7"
  },
  {
    "iso2": "KE",
    "code": "+254",
    "name": "Kenya",
    "example": "712123456",
    "display": "KE +254"
  },
  {
    "iso2": "KI",
    "code": "+686",
    "name": "Kiribati",
    "example": "61234",
    "display": "KI +686"
  },
  {
    "iso2": "XK",
    "code": "+383",
    "name": "Kosovo",
    "example": null,
    "display": "XK +383"
  },
  {
    "iso2": "KW",
    "code": "+965",
    "name": "Kuwait",
    "example": "50012345",
    "display": "KW +965"
  },
  {
    "iso2": "KG",
    "code": "+996",
    "name": "Kyrgyzstan",
    "example": "700123456",
    "display": "KG +996"
  },
  {
    "iso2": "LA",
    "code": "+856",
    "name": "Laos",
    "example": "2023123456",
    "display": "LA +856"
  },
  {
    "iso2": "LV",
    "code": "+371",
    "name": "Latvia",
    "example": "21234567",
    "display": "LV +371"
  },
  {
    "iso2": "LB",
    "code": "+961",
    "name": "Lebanon",
    "example": "71123456",
    "display": "LB +961"
  },
  {
    "iso2": "LS",
    "code": "+266",
    "name": "Lesotho",
    "example": "50123456",
    "display": "LS +266"
  },
  {
    "iso2": "LR",
    "code": "+231",
    "name": "Liberia",
    "example": "4612345",
    "display": "LR +231"
  },
  {
    "iso2": "LY",
    "code": "+218",
    "name": "Libya",
    "example": "912345678",
    "display": "LY +218"
  },
  {
    "iso2": "LI",
    "code": "+423",
    "name": "Liechtenstein",
    "example": "661234567",
    "display": "LI +423"
  },
  {
    "iso2": "LT",
    "code": "+370",
    "name": "Lithuania",
    "example": "61234567",
    "display": "LT +370"
  },
  {
    "iso2": "LU",
    "code": "+352",
    "name": "Luxembourg",
    "example": "628123456",
    "display": "LU +352"
  },
  {
    "iso2": "MO",
    "code": "+853",
    "name": "Macau",
    "example": "66123456",
    "display": "MO +853"
  },
  {
    "iso2": "MG",
    "code": "+261",
    "name": "Madagascar",
    "example": "301234567",
    "display": "MG +261"
  },
  {
    "iso2": "MW",
    "code": "+265",
    "name": "Malawi",
    "example": "991234567",
    "display": "MW +265"
  },
  {
    "iso2": "MY",
    "code": "+60",
    "name": "Malaysia",
    "example": "123456789",
    "display": "MY +60"
  },
  {
    "iso2": "MV",
    "code": "+960",
    "name": "Maldives",
    "example": "7712345",
    "display": "MV +960"
  },
  {
    "iso2": "ML",
    "code": "+223",
    "name": "Mali",
    "example": "65012345",
    "display": "ML +223"
  },
  {
    "iso2": "MT",
    "code": "+356",
    "name": "Malta",
    "example": "96961234",
    "display": "MT +356"
  },
  {
    "iso2": "MH",
    "code": "+692",
    "name": "Marshall Islands",
    "example": "2351234",
    "display": "MH +692"
  },
  {
    "iso2": "MQ",
    "code": "+596",
    "name": "Martinique",
    "example": "696201234",
    "display": "MQ +596"
  },
  {
    "iso2": "MR",
    "code": "+222",
    "name": "Mauritania",
    "example": "22123456",
    "display": "MR +222"
  },
  {
    "iso2": "MU",
    "code": "+230",
    "name": "Mauritius",
    "example": "2512345",
    "display": "MU +230"
  },
  {
    "iso2": "YT",
    "code": "+262",
    "name": "Mayotte",
    "example": "639123456",
    "display": "YT +262"
  },
  {
    "iso2": "MX",
    "code": "+52",
    "name": "Mexico",
    "example": "12221234567",
    "display": "MX +52"
  },
  {
    "iso2": "FM",
    "code": "+691",
    "name": "Micronesia",
    "example": "3501234",
    "display": "FM +691"
  },
  {
    "iso2": "MD",
    "code": "+373",
    "name": "Moldova",
    "example": "65012345",
    "display": "MD +373"
  },
  {
    "iso2": "MC",
    "code": "+377",
    "name": "Monaco",
    "example": "612345678",
    "display": "MC +377"
  },
  {
    "iso2": "MN",
    "code": "+976",
    "name": "Mongolia",
    "example": "88123456",
    "display": "MN +976"
  },
  {
    "iso2": "ME",
    "code": "+382",
    "name": "Montenegro",
    "example": "67622901",
    "display": "ME +382"
  },
  {
    "iso2": "MS",
    "code": "+1",
    "name": "Montserrat",
    "example": "6644923456",
    "display": "MS +1"
  },
  {
    "iso2": "MA",
    "code": "+212",
    "name": "Morocco",
    "example": "650123456",
    "display": "MA +212"
  },
  {
    "iso2": "MZ",
    "code": "+258",
    "name": "Mozambique",
    "example": "821234567",
    "display": "MZ +258"
  },
  {
    "iso2": "MM",
    "code": "+95",
    "name": "Myanmar [Burma]",
    "example": "92123456",
    "display": "MM +95"
  },
  {
    "iso2": "NA",
    "code": "+264",
    "name": "Namibia",
    "example": "811234567",
    "display": "NA +264"
  },
  {
    "iso2": "NR",
    "code": "+674",
    "name": "Nauru",
    "example": "5551234",
    "display": "NR +674"
  },
  {
    "iso2": "NP",
    "code": "+977",
    "name": "Nepal",
    "example": "9841234567",
    "display": "NP +977"
  },
  {
    "iso2": "NL",
    "code": "+31",
    "name": "Netherlands",
    "example": "612345678",
    "display": "NL +31"
  },
  {
    "iso2": "NC",
    "code": "+687",
    "name": "New Caledonia",
    "example": "751234",
    "display": "NC +687"
  },
  {
    "iso2": "NZ",
    "code": "+64",
    "name": "New Zealand",
    "example": "211234567",
    "display": "NZ +64"
  },
  {
    "iso2": "NI",
    "code": "+505",
    "name": "Nicaragua",
    "example": "81234567",
    "display": "NI +505"
  },
  {
    "iso2": "NE",
    "code": "+227",
    "name": "Niger",
    "example": "93123456",
    "display": "NE +227"
  },
  {
    "iso2": "NG",
    "code": "+234",
    "name": "Nigeria",
    "example": "8021234567",
    "display": "NG +234"
  },
  {
    "iso2": "NU",
    "code": "+683",
    "name": "Niue",
    "example": "1234",
    "display": "NU +683"
  },
  {
    "iso2": "NF",
    "code": "+672",
    "name": "Norfolk Island",
    "example": "381234",
    "display": "NF +672"
  },
  {
    "iso2": "KP",
    "code": "+850",
    "name": "North Korea",
    "example": "1921234567",
    "display": "KP +850"
  },
  {
    "iso2": "MK",
    "code": "+389",
    "name": "North Macedonia",
    "example": "72345678",
    "display": "MK +389"
  },
  {
    "iso2": "MP",
    "code": "+1",
    "name": "Northern Mariana Islands",
    "example": "6702345678",
    "display": "MP +1"
  },
  {
    "iso2": "NO",
    "code": "+47",
    "name": "Norway",
    "example": "41234567",
    "display": "NO +47"
  },
  {
    "iso2": "OM",
    "code": "+968",
    "name": "Oman",
    "example": "92123456",
    "display": "OM +968"
  },
  {
    "iso2": "PK",
    "code": "+92",
    "name": "Pakistan",
    "example": "3012345678",
    "display": "PK +92"
  },
  {
    "iso2": "PW",
    "code": "+680",
    "name": "Palau",
    "example": "6201234",
    "display": "PW +680"
  },
  {
    "iso2": "PS",
    "code": "+970",
    "name": "Palestinian Territories",
    "example": "599123456",
    "display": "PS +970"
  },
  {
    "iso2": "PA",
    "code": "+507",
    "name": "Panama",
    "example": "60012345",
    "display": "PA +507"
  },
  {
    "iso2": "PG",
    "code": "+675",
    "name": "Papua New Guinea",
    "example": "6812345",
    "display": "PG +675"
  },
  {
    "iso2": "PY",
    "code": "+595",
    "name": "Paraguay",
    "example": "961456789",
    "display": "PY +595"
  },
  {
    "iso2": "PE",
    "code": "+51",
    "name": "Peru",
    "example": "912345678",
    "display": "PE +51"
  },
  {
    "iso2": "PH",
    "code": "+63",
    "name": "Philippines",
    "example": "9051234567",
    "display": "PH +63"
  },
  {
    "iso2": "PL",
    "code": "+48",
    "name": "Poland",
    "example": "512345678",
    "display": "PL +48"
  },
  {
    "iso2": "PT",
    "code": "+351",
    "name": "Portugal",
    "example": "912345678",
    "display": "PT +351"
  },
  {
    "iso2": "PR",
    "code": "+1",
    "name": "Puerto Rico",
    "example": "7872345678",
    "display": "PR +1"
  },
  {
    "iso2": "QA",
    "code": "+974",
    "name": "Qatar",
    "example": "33123456",
    "display": "QA +974"
  },
  {
    "iso2": "CG",
    "code": "+242",
    "name": "Republic of Congo",
    "example": "061234567",
    "display": "CG +242"
  },
  {
    "iso2": "RO",
    "code": "+40",
    "name": "Romania",
    "example": "712345678",
    "display": "RO +40"
  },
  {
    "iso2": "RU",
    "code": "+7",
    "name": "Russia",
    "example": "9123456789",
    "display": "RU +7"
  },
  {
    "iso2": "RW",
    "code": "+250",
    "name": "Rwanda",
    "example": "720123456",
    "display": "RW +250"
  },
  {
    "iso2": "RE",
    "code": "+262",
    "name": "Réunion",
    "example": "692123456",
    "display": "RE +262"
  },
  {
    "iso2": "BL",
    "code": "+590",
    "name": "Saint Barthélemy",
    "example": "690221234",
    "display": "BL +590"
  },
  {
    "iso2": "SH",
    "code": "+290",
    "name": "Saint Helena",
    "example": null,
    "display": "SH +290"
  },
  {
    "iso2": "MF",
    "code": "+590",
    "name": "Saint Martin",
    "example": "690221234",
    "display": "MF +590"
  },
  {
    "iso2": "PM",
    "code": "+508",
    "name": "Saint Pierre and Miquelon",
    "example": "551234",
    "display": "PM +508"
  },
  {
    "iso2": "WS",
    "code": "+685",
    "name": "Samoa",
    "example": "601234",
    "display": "WS +685"
  },
  {
    "iso2": "SM",
    "code": "+378",
    "name": "San Marino",
    "example": "66661212",
    "display": "SM +378"
  },
  {
    "iso2": "SA",
    "code": "+966",
    "name": "Saudi Arabia",
    "example": "512345678",
    "display": "SA +966"
  },
  {
    "iso2": "SN",
    "code": "+221",
    "name": "Senegal",
    "example": "701012345",
    "display": "SN +221"
  },
  {
    "iso2": "RS",
    "code": "+381",
    "name": "Serbia",
    "example": "601234567",
    "display": "RS +381"
  },
  {
    "iso2": "SC",
    "code": "+248",
    "name": "Seychelles",
    "example": "2510123",
    "display": "SC +248"
  },
  {
    "iso2": "SL",
    "code": "+232",
    "name": "Sierra Leone",
    "example": "25123456",
    "display": "SL +232"
  },
  {
    "iso2": "SX",
    "code": "+1",
    "name": "Sint Maarten",
    "example": "7215205678",
    "display": "SX +1"
  },
  {
    "iso2": "SK",
    "code": "+421",
    "name": "Slovakia",
    "example": "912123456",
    "display": "SK +421"
  },
  {
    "iso2": "SI",
    "code": "+386",
    "name": "Slovenia",
    "example": "31234567",
    "display": "SI +386"
  },
  {
    "iso2": "SB",
    "code": "+677",
    "name": "Solomon Islands",
    "example": "7421234",
    "display": "SB +677"
  },
  {
    "iso2": "SO",
    "code": "+252",
    "name": "Somalia",
    "example": "90792024",
    "display": "SO +252"
  },
  {
    "iso2": "ZA",
    "code": "+27",
    "name": "South Africa",
    "example": "711234567",
    "display": "ZA +27"
  },
  {
    "iso2": "GS",
    "code": "+500",
    "name": "South Georgia and the South Sandwich Islands",
    "example": null,
    "display": "GS +500"
  },
  {
    "iso2": "KR",
    "code": "+82",
    "name": "South Korea",
    "example": "1023456789",
    "display": "KR +82"
  },
  {
    "iso2": "SS",
    "code": "+211",
    "name": "South Sudan",
    "example": "977123456",
    "display": "SS +211"
  },
  {
    "iso2": "ES",
    "code": "+34",
    "name": "Spain",
    "example": "612345678",
    "display": "ES +34"
  },
  {
    "iso2": "LK",
    "code": "+94",
    "name": "Sri Lanka",
    "example": "712345678",
    "display": "LK +94"
  },
  {
    "iso2": "KN",
    "code": "+1",
    "name": "St. Kitts",
    "example": "8695561234",
    "display": "KN +1"
  },
  {
    "iso2": "LC",
    "code": "+1",
    "name": "St. Lucia",
    "example": "7582845678",
    "display": "LC +1"
  },
  {
    "iso2": "VC",
    "code": "+1",
    "name": "St. Vincent",
    "example": "7844301234",
    "display": "VC +1"
  },
  {
    "iso2": "SD",
    "code": "+249",
    "name": "Sudan",
    "example": "911231234",
    "display": "SD +249"
  },
  {
    "iso2": "SR",
    "code": "+597",
    "name": "Suriname",
    "example": "7412345",
    "display": "SR +597"
  },
  {
    "iso2": "SJ",
    "code": "+47",
    "name": "Svalbard and Jan Mayen",
    "example": "41234567",
    "display": "SJ +47"
  },
  {
    "iso2": "SE",
    "code": "+46",
    "name": "Sweden",
    "example": "701234567",
    "display": "SE +46"
  },
  {
    "iso2": "CH",
    "code": "+41",
    "name": "Switzerland",
    "example": "741234567",
    "display": "CH +41"
  },
  {
    "iso2": "SY",
    "code": "+963",
    "name": "Syria",
    "example": "944567890",
    "display": "SY +963"
  },
  {
    "iso2": "ST",
    "code": "+239",
    "name": "São Tomé and Príncipe",
    "example": "9812345",
    "display": "ST +239"
  },
  {
    "iso2": "TW",
    "code": "+886",
    "name": "Taiwan",
    "example": "912345678",
    "display": "TW +886"
  },
  {
    "iso2": "TJ",
    "code": "+992",
    "name": "Tajikistan",
    "example": "917123456",
    "display": "TJ +992"
  },
  {
    "iso2": "TZ",
    "code": "+255",
    "name": "Tanzania",
    "example": "612345678",
    "display": "TZ +255"
  },
  {
    "iso2": "TH",
    "code": "+66",
    "name": "Thailand",
    "example": "812345678",
    "display": "TH +66"
  },
  {
    "iso2": "TG",
    "code": "+228",
    "name": "Togo",
    "example": "90112345",
    "display": "TG +228"
  },
  {
    "iso2": "TK",
    "code": "+690",
    "name": "Tokelau",
    "example": "5190",
    "display": "TK +690"
  },
  {
    "iso2": "TO",
    "code": "+676",
    "name": "Tonga",
    "example": "7715123",
    "display": "TO +676"
  },
  {
    "iso2": "TT",
    "code": "+1",
    "name": "Trinidad/Tobago",
    "example": "8682911234",
    "display": "TT +1"
  },
  {
    "iso2": "TN",
    "code": "+216",
    "name": "Tunisia",
    "example": "20123456",
    "display": "TN +216"
  },
  {
    "iso2": "TR",
    "code": "+90",
    "name": "Turkey",
    "example": "5012345678",
    "display": "TR +90"
  },
  {
    "iso2": "TM",
    "code": "+993",
    "name": "Turkmenistan",
    "example": "66123456",
    "display": "TM +993"
  },
  {
    "iso2": "TC",
    "code": "+1",
    "name": "Turks and Caicos Islands",
    "example": "6492311234",
    "display": "TC +1"
  },
  {
    "iso2": "TV",
    "code": "+688",
    "name": "Tuvalu",
    "example": "901234",
    "display": "TV +688"
  },
  {
    "iso2": "VI",
    "code": "+1",
    "name": "U.S. Virgin Islands",
    "example": "3406421234",
    "display": "VI +1"
  },
  {
    "iso2": "UG",
    "code": "+256",
    "name": "Uganda",
    "example": "712345678",
    "display": "UG +256"
  },
  {
    "iso2": "UA",
    "code": "+380",
    "name": "Ukraine",
    "example": "391234567",
    "display": "UA +380"
  },
  {
    "iso2": "AE",
    "code": "+971",
    "name": "United Arab Emirates",
    "example": "501234567",
    "display": "AE +971"
  },
  {
    "iso2": "GB",
    "code": "+44",
    "name": "United Kingdom",
    "example": "7400123456",
    "display": "GB +44"
  },
  {
    "iso2": "US",
    "code": "+1",
    "name": "United States",
    "example": "2012345678",
    "display": "US +1"
  },
  {
    "iso2": "UY",
    "code": "+598",
    "name": "Uruguay",
    "example": "94231234",
    "display": "UY +598"
  },
  {
    "iso2": "UZ",
    "code": "+998",
    "name": "Uzbekistan",
    "example": "912345678",
    "display": "UZ +998"
  },
  {
    "iso2": "VU",
    "code": "+678",
    "name": "Vanuatu",
    "example": "5912345",
    "display": "VU +678"
  },
  {
    "iso2": "VA",
    "code": "+379",
    "name": "Vatican City",
    "example": null,
    "display": "VA +379"
  },
  {
    "iso2": "VE",
    "code": "+58",
    "name": "Venezuela",
    "example": "4121234567",
    "display": "VE +58"
  },
  {
    "iso2": "VN",
    "code": "+84",
    "name": "Vietnam",
    "example": "912345678",
    "display": "VN +84"
  },
  {
    "iso2": "WF",
    "code": "+681",
    "name": "Wallis and Futuna",
    "example": "501234",
    "display": "WF +681"
  },
  {
    "iso2": "EH",
    "code": "+212",
    "name": "Western Sahara",
    "example": null,
    "display": "EH +212"
  },
  {
    "iso2": "YE",
    "code": "+967",
    "name": "Yemen",
    "example": "712345678",
    "display": "YE +967"
  },
  {
    "iso2": "ZM",
    "code": "+260",
    "name": "Zambia",
    "example": "955123456",
    "display": "ZM +260"
  },
  {
    "iso2": "ZW",
    "code": "+263",
    "name": "Zimbabwe",
    "example": "711234567",
    "display": "ZW +263"
  },
  {
    "iso2": "AX",
    "code": "+358",
    "name": "Åland Islands",
    "example": "412345678",
    "display": "AX +358"
  }
];

export const iso2ToDialCode = {
  "SG": "+65",
  "AF": "+93",
  "AL": "+355",
  "DZ": "+213",
  "AS": "+1",
  "AD": "+376",
  "AO": "+244",
  "AI": "+1",
  "AG": "+1",
  "AR": "+54",
  "AM": "+374",
  "AW": "+297",
  "AC": "+247",
  "AU": "+61",
  "AT": "+43",
  "AZ": "+994",
  "BS": "+1",
  "BH": "+973",
  "BD": "+880",
  "BB": "+1",
  "BY": "+375",
  "BE": "+32",
  "BZ": "+501",
  "BJ": "+229",
  "BM": "+1",
  "BT": "+975",
  "BO": "+591",
  "BA": "+387",
  "BW": "+267",
  "BR": "+55",
  "IO": "+246",
  "VG": "+1",
  "BN": "+673",
  "BG": "+359",
  "BF": "+226",
  "BI": "+257",
  "KH": "+855",
  "CM": "+237",
  "CA": "+1",
  "CV": "+238",
  "BQ": "+599",
  "KY": "+1",
  "CF": "+236",
  "TD": "+235",
  "CL": "+56",
  "CN": "+86",
  "CX": "+61",
  "CC": "+61",
  "CO": "+57",
  "KM": "+269",
  "CK": "+682",
  "CR": "+506",
  "HR": "+385",
  "CU": "+53",
  "CW": "+599",
  "CY": "+357",
  "CZ": "+420",
  "CI": "+225",
  "CD": "+243",
  "DK": "+45",
  "DJ": "+253",
  "DM": "+1",
  "DO": "+1",
  "TL": "+670",
  "EC": "+593",
  "EG": "+20",
  "SV": "+503",
  "GQ": "+240",
  "ER": "+291",
  "EE": "+372",
  "SZ": "+268",
  "ET": "+251",
  "FK": "+500",
  "FO": "+298",
  "FJ": "+679",
  "FI": "+358",
  "FR": "+33",
  "GF": "+594",
  "PF": "+689",
  "GA": "+241",
  "GM": "+220",
  "GE": "+995",
  "DE": "+49",
  "GH": "+233",
  "GI": "+350",
  "GR": "+30",
  "GL": "+299",
  "GD": "+1",
  "GP": "+590",
  "GU": "+1",
  "GT": "+502",
  "GG": "+44",
  "GN": "+224",
  "GW": "+245",
  "GY": "+592",
  "HT": "+509",
  "HM": "+672",
  "HN": "+504",
  "HK": "+852",
  "HU": "+36",
  "IS": "+354",
  "IN": "+91",
  "ID": "+62",
  "IR": "+98",
  "IQ": "+964",
  "IE": "+353",
  "IM": "+44",
  "IL": "+972",
  "IT": "+39",
  "JM": "+1",
  "JP": "+81",
  "JE": "+44",
  "JO": "+962",
  "KZ": "+7",
  "KE": "+254",
  "KI": "+686",
  "XK": "+383",
  "KW": "+965",
  "KG": "+996",
  "LA": "+856",
  "LV": "+371",
  "LB": "+961",
  "LS": "+266",
  "LR": "+231",
  "LY": "+218",
  "LI": "+423",
  "LT": "+370",
  "LU": "+352",
  "MO": "+853",
  "MG": "+261",
  "MW": "+265",
  "MY": "+60",
  "MV": "+960",
  "ML": "+223",
  "MT": "+356",
  "MH": "+692",
  "MQ": "+596",
  "MR": "+222",
  "MU": "+230",
  "YT": "+262",
  "MX": "+52",
  "FM": "+691",
  "MD": "+373",
  "MC": "+377",
  "MN": "+976",
  "ME": "+382",
  "MS": "+1",
  "MA": "+212",
  "MZ": "+258",
  "MM": "+95",
  "NA": "+264",
  "NR": "+674",
  "NP": "+977",
  "NL": "+31",
  "NC": "+687",
  "NZ": "+64",
  "NI": "+505",
  "NE": "+227",
  "NG": "+234",
  "NU": "+683",
  "NF": "+672",
  "KP": "+850",
  "MK": "+389",
  "MP": "+1",
  "NO": "+47",
  "OM": "+968",
  "PK": "+92",
  "PW": "+680",
  "PS": "+970",
  "PA": "+507",
  "PG": "+675",
  "PY": "+595",
  "PE": "+51",
  "PH": "+63",
  "PL": "+48",
  "PT": "+351",
  "PR": "+1",
  "QA": "+974",
  "CG": "+242",
  "RO": "+40",
  "RU": "+7",
  "RW": "+250",
  "RE": "+262",
  "BL": "+590",
  "SH": "+290",
  "MF": "+590",
  "PM": "+508",
  "WS": "+685",
  "SM": "+378",
  "SA": "+966",
  "SN": "+221",
  "RS": "+381",
  "SC": "+248",
  "SL": "+232",
  "SX": "+1",
  "SK": "+421",
  "SI": "+386",
  "SB": "+677",
  "SO": "+252",
  "ZA": "+27",
  "GS": "+500",
  "KR": "+82",
  "SS": "+211",
  "ES": "+34",
  "LK": "+94",
  "KN": "+1",
  "LC": "+1",
  "VC": "+1",
  "SD": "+249",
  "SR": "+597",
  "SJ": "+47",
  "SE": "+46",
  "CH": "+41",
  "SY": "+963",
  "ST": "+239",
  "TW": "+886",
  "TJ": "+992",
  "TZ": "+255",
  "TH": "+66",
  "TG": "+228",
  "TK": "+690",
  "TO": "+676",
  "TT": "+1",
  "TN": "+216",
  "TR": "+90",
  "TM": "+993",
  "TC": "+1",
  "TV": "+688",
  "VI": "+1",
  "UG": "+256",
  "UA": "+380",
  "AE": "+971",
  "GB": "+44",
  "US": "+1",
  "UY": "+598",
  "UZ": "+998",
  "VU": "+678",
  "VA": "+379",
  "VE": "+58",
  "VN": "+84",
  "WF": "+681",
  "EH": "+212",
  "YE": "+967",
  "ZM": "+260",
  "ZW": "+263",
  "AX": "+358"
};

// Helper to find by iso2 (returns full record or null)
export function getPhoneCodeByIso2(iso2) {
  if (!iso2) return null;
  const m = phoneCountryCodes.find(x => x.iso2 === iso2.toUpperCase());
  return m || null;
}

// Helper to build label like "SG +65"
export function countryDialLabel(rec) {
  if (!rec) return "";
  return `${rec.iso2} ${rec.code}`;
}